import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    /** app类型 */
    public appCategoryList: {
        categoryId: number;
        categoryName: string;
    }[] = [];
    /** 选中的app类型 */
    public appCategory: number = 0;
    /** 私有应用 公有 所有 */
    public isOpen: string = 'all';
    /** 分页信息 设置 */
    public pageNum: number = 1;
    public pageSize: number = 12;
    public total: number = 0;
    /** 模糊搜索 */
    public searchInfo: string = ''; 
    /** app列表 */
    public appList: {
        appDescription: string;
        appIcon: string;
        appId: number;
        appIndexUri: string;
        appKey: string;
        appName: string
        categoryName: string;
        isActivated: number;
    }[] = [];
}


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppManagement/Modules.State.ts